module.exports = __webpack_public_path__ + "73e4e3ea61cde8e656dd22351eef6734.svg";